import React from 'react';
import { useDroppable } from '@dnd-kit/core';

interface DroppableSlotProps {
  u: number;
  mount: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  activeOverSlot?: { u: number; mount: string } | null;
  isValidTarget?: boolean;
  isDark?: boolean;
}

/**
 * Empty droppable rack slot cell.
 * Highlights on drag-over: cyan = valid drop target, red = conflict.
 */
export function DroppableSlot({ u, mount, onClick, style, activeOverSlot, isValidTarget, isDark = true }: DroppableSlotProps) {
  const { setNodeRef } = useDroppable({
    id: `slot-${u}-${mount}`,
    data: { u, mount },
  });

  const isHighlighted = activeOverSlot?.u === u && activeOverSlot?.mount === mount;

  let bgClass = isDark
    ? 'bg-slate-900/10 hover:bg-slate-800/20'
    : 'bg-gray-50/60 hover:bg-gray-100/80';

  if (isHighlighted) {
    bgClass = isValidTarget
      ? 'bg-cyan-500/20 border-cyan-400 shadow-[0_0_10px_rgba(6,182,212,0.4)]'
      : 'bg-red-500/20 border-red-500 shadow-[0_0_10px_rgba(239,68,68,0.4)]';
  }

  return (
    <div
      ref={setNodeRef}
      onClick={onClick}
      style={style}
      className={`border-b flex items-center px-1 text-[8px] font-mono transition-colors ${
        isDark ? 'border-slate-800 text-slate-700' : 'border-gray-300/80 text-gray-400'
      } ${bgClass}`}
    />
  );
}
